const profile = {
  title: "Profilim",
  premiumBtn: "Premium'a geç",
  orderInfoTitle: "Hesap izin bilgisi.",
  tableProduct: "Ürün",
  tableStatus: "Durum",
  tablePermissionDate: "İzin tarihi",
  tableValidPeriod: "Geçerli Dönem",
  validStauts: "Geçerli",
  expiredStauts: "Süresi doldu",
  noData: "Veri yok",
};

export default profile;
